let formatearduedateTo = function() {
	this.duedateTo = new Date(
		(new Date(this.duedateTo).toISOString() + "").slice(0, 10) + "T23:31:04.000Z"
		).toISOString();
};
export default formatearduedateTo;
